import { forwardRef } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Custom styles for MDModal
import MDModalRoot from "./MDModalRoot";

// Material Dashboard 2 PRO React contexts
import { useMaterialUIController } from "context";

// Import MUI components for Modal functionality
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import MDButton from "components/MDButton";  // Assuming MDButton is available
import { Card } from "@mui/material";

const contentStyle = {
    height: '400px',
    margin: '10px',
    paddingTop: '10px',
    overflowY: 'auto'
}

const footerStyle = {
    paddingTop: "10px", 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center', 
    gap: '1rem',
    borderTop: '1px solid #fff'
}

const MDModal = forwardRef(
    ({ open, onClose, title, content, footer, children, ...rest }, ref) => {
        const [controller] = useMaterialUIController();
        const { darkMode } = controller;

        return (
            <MDModalRoot
                {...rest}
                ref={ref}
                open={open}
                onClose={onClose}
                ownerState={{ darkMode }}
            >
                <Modal
                    open={open}
                    onClose={onClose}
                    closeAfterTransition
                    aria-labelledby="modal-title"
                    aria-describedby="modal-description"
                >
                    <Box
                    onClick={onClose}
                    sx={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    p: 2,
                    }}
                >

                    <Card
                    onClick={(e) => e.stopPropagation()}
                        sx={{
                            width: { xs: "90%", sm: "60%" }, // Set the desired width here
                            backgroundColor: 'white',
                            p: 1,
                        }}
                    >
                        {title && (
                            <h2 id="modal-title" style={{ marginBottom: "5px", color: darkMode ? '#fff' : '#000' }}>
                                {title}
                            </h2>
                        )}
                        <Box id="modal-description" sx={{...contentStyle, height: { xs: "400px", sm: "650px" }}}>
                            {content || children}
                        </Box>
                        <div style={footerStyle}>
                            <MDButton onClick={onClose} color="primary" variant="contained">
                                Close
                            </MDButton>
                            {footer}
                        </div>
                    </Card>
      </Box>
                </Modal>
            </MDModalRoot>
        );
    }
);

// Setting default values for the props of MDModal
MDModal.defaultProps = {
    open: false,
    title: "",
    footer: null,
};

// Typechecking props for the MDModal
MDModal.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string,
    content: PropTypes.node,
    footer: PropTypes.node,
    children: PropTypes.node,
};

export default MDModal;